import React, { useState } from "react";
import "../styles/UpdatePaymentMethod.css";
import {
    useNavigate,
  Link,
  useLocation
} from "react-router-dom";

// ── Icons ──────────────────────────────────────────────────────────────
const Icons = {
  Dashboard: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="9" rx="1" /><rect x="14" y="3" width="7" height="5" rx="1" />
      <rect x="14" y="12" width="7" height="9" rx="1" /><rect x="3" y="16" width="7" height="5" rx="1" />
    </svg>
  ),
  Conversions: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
    </svg>
  ),
  Payments: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="1" y="4" width="22" height="16" rx="2" /><line x1="1" y1="10" x2="23" y2="10" />
    </svg>
  ),
  Settings: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3" />
      <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" />
    </svg>
  ),
  Help: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" /><path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  ),
  ArrowLeft: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="19" y1="12" x2="5" y2="12" /><polyline points="12 19 5 12 12 5" />
    </svg>
  ),
  CreditCard: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#10B981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="1" y="4" width="22" height="16" rx="2" /><line x1="1" y1="10" x2="23" y2="10" />
    </svg>
  ),
  Smartphone: () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#10B981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="5" y="2" width="14" height="20" rx="2" /><line x1="12" y1="18" x2="12.01" y2="18" />
    </svg>
  ),
  Upi: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="5" y="2" width="14" height="20" rx="2" /><line x1="12" y1="18" x2="12.01" y2="18" />
    </svg>
  ),
  CheckCircle: () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#10B981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 11.08V12a10 10 0 11-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" />
    </svg>
  ),
  Lock: () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#10B981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="11" width="18" height="11" rx="2" /><path d="M7 11V7a5 5 0 0110 0v4" />
    </svg>
  ),
  Refresh: () => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="23 4 23 10 17 10" /><polyline points="1 20 1 14 7 14" />
      <path d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15" />
    </svg>
  ),
};

// ── Input Field ────────────────────────────────────────────────────────
function InputField({ label, placeholder, value, onChange, suffix, prefilled }) {
  return (
    <div className="up-field">
      <label className="up-field__label">{label}</label>
      <div className="up-field__input-wrapper">
        <input
          type="text"
          className={`up-field__input ${prefilled ? "up-field__input--prefilled" : ""}`}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
        />
        {suffix && <div className="up-field__suffix">{suffix}</div>}
      </div>
    </div>
  );
}

// ── Sidebar ────────────────────────────────────────────────────────────
function Sidebar() {
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogout = () => {
                      localStorage.removeItem("currentUser");
                      localStorage.removeItem("selectedPlan");
                      navigate("/");
                    };

  const NAV_ITEMS = [
    { label: "Dashboard", icon: <Icons.Dashboard />, active: false ,path: "/dashboard"},
    { label: "Conversions", icon: <Icons.Conversions />, active: false,path: "/conversions" },
    { label: "Payments", icon: <Icons.Payments />, active: true ,path: "/payments"},
    { label: "Settings", icon: <Icons.Settings />, active: false,path: "/settings" },
    { label: "Help", icon: <Icons.Help />, active: false,path: "/help" },
  ];

  return (
    <aside className="up-sidebar">
      <div className="up-sidebar__upper">
        <div className="up-sidebar__profile">
          <div className="up-sidebar__avatar">AS</div>
          <div>
            <div className="up-sidebar__name">ConvertPro</div>
            <div className="up-sidebar__role">Alex Sterling · Admin</div>
          </div>
        </div>
        <nav className="up-sidebar__nav">
          {NAV_ITEMS.map((item) => (
                                                                <Link
                                                                  key={item.label}
                                                                  to={item.path}
                                                                  className={`db-nav-item ${
                                                                    location.pathname === item.path
                                                                      ? "db-nav-item--active"
                                                                      : ""
                                                                  }`}
                                                                >
                                                                  <span className="db-nav-icon">
                                                                    {item.icon}
                                                                  </span>
                                                                  {item.label}
                                                                </Link>
                                                              ))}
      {/* ─── Logout separator + button ─── */}
                                                                                                                                    <div className="db-nav-separator" />
                                                                                                                                    <button className="db-nav-item db-nav-logout" onClick={handleLogout}>
                                                                                                                                      <span className="db-nav-icon">
                                                                                                                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#E24646" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                                                                                          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                                                                                                                                          <polyline points="16 17 21 12 16 7" />
                                                                                                                                          <line x1="21" y1="12" x2="9" y2="12" />
                                                                                                                                        </svg>
                                                                                                                                      </span>
                                                                                                                                      Log Out
                                                                                                                                    </button>
        </nav>
      </div>
    </aside>
  );
}

// ── Card Preview Sidebar ───────────────────────────────────────────────
function CardPreview({ cardNumber, cardholderName, expiry }) {
  const formatted = cardNumber
    ? cardNumber.replace(/(.{4})/g, "$1 ").trim()
    : "•••• •••• •••• ••••";

  return (
    <div className="up-preview">
      <div>
        <h3 className="up-preview__title">Live Preview</h3>
        <p className="up-preview__subtitle">Updates as you type</p>
      </div>

      <div className="up-card-graphic">
        <div className="up-card-graphic__circle up-card-graphic__circle--top" />
        <div className="up-card-graphic__circle up-card-graphic__circle--bottom" />
        <div className="up-card-graphic__row">
          <span className="up-card-graphic__brand">ConvertPro</span>
          <span className="up-card-graphic__badge">VISA</span>
        </div>
        <div className="up-card-graphic__bottom">
          <div className="up-card-graphic__number">{formatted}</div>
          <div className="up-card-graphic__meta">
            <div>
              <div className="up-card-graphic__label">CARDHOLDER</div>
              <div className="up-card-graphic__value">{cardholderName || "Your Name"}</div>
            </div>
            <div className="up-card-graphic__meta-right">
              <div className="up-card-graphic__label">EXPIRES</div>
              <div className="up-card-graphic__value">{expiry || "MM/YY"}</div>
            </div>
          </div>
        </div>
      </div>

      <div className="up-auto-sync">
        <span className="up-auto-sync__badge"><Icons.Refresh /> Auto-sync</span>
        <div className="up-auto-sync__line" />
      </div>

      <div className="up-security">
        <div className="up-security__icon"><Icons.Lock /></div>
        <div>
          <div className="up-security__title">Secure Payment Gateway</div>
          <div className="up-security__subtitle">SSL 256-bit encryption</div>
        </div>
      </div>

      <div className="up-trust">
        <div className="up-trust__heading">TRUST & SECURITY</div>
        {[
          "PCI-DSS compliant payment processing",
          "Auto-renewal is managed from your billing settings",
          "Card details are tokenized and never stored in plain text",
        ].map((text) => (
          <div key={text} className="up-trust__row">
            <Icons.CheckCircle />
            <span>{text}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

// ── UPI Preview Sidebar ────────────────────────────────────────────────
function UpiPreview({ upiId }) {
  return (
    <div className="up-preview">
      <div>
        <h3 className="up-preview__title">Live Preview</h3>
        <p className="up-preview__subtitle">Updates as you type</p>
      </div>

      <div className="up-card-graphic up-card-graphic--upi">
        <div className="up-card-graphic__circle up-card-graphic__circle--top" />
        <div className="up-card-graphic__row">
          <span className="up-card-graphic__brand">UPI Pay</span>
          <span className="up-card-graphic__badge up-card-graphic__badge--upi">UPI</span>
        </div>
        <div className="up-card-graphic__upi-center">
          <div className="up-card-graphic__upi-icon"><Icons.Upi /></div>
        </div>
        <div className="up-card-graphic__upi-bottom">
          <span className="up-card-graphic__upi-id">{upiId || "yourname@upi"}</span>
          <span className="up-card-graphic__upi-status">ACTIVE</span>
        </div>
      </div>

      <div className="up-auto-sync">
        <span className="up-auto-sync__badge"><Icons.Refresh /> Auto-sync</span>
        <div className="up-auto-sync__line" />
      </div>

      <div className="up-upi-apps">
        <div className="up-upi-apps__title">Supported UPI Apps</div>
        <div className="up-upi-apps__grid">
          {[
            { name: "Google Pay", color: "#4285F4", letter: "G" },
            { name: "PhonePe", color: "#5F259F", letter: "P" },
            { name: "Paytm", color: "#00BAF2", letter: "P" },
            { name: "BHIM", color: "#E53935", letter: "B" },
          ].map((app) => (
            <div key={app.name} className="up-upi-apps__chip">
              <span className="up-upi-apps__icon" style={{ backgroundColor: app.color }}>{app.letter}</span>
              <span>{app.name}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="up-how-it-works">
        <div className="up-how-it-works__title">How it works</div>
        {["Enter your UPI ID", "Verify on your UPI app", "Payment linked automatically"].map((step, i) => (
          <div key={step} className="up-how-it-works__step">
            <span className="up-how-it-works__number">{i + 1}</span>
            <span>{step}</span>
          </div>
        ))}
      </div>

      <div className="up-security">
        <div className="up-security__icon"><Icons.Lock /></div>
        <div>
          <div className="up-security__title">Secure Payment Gateway</div>
          <div className="up-security__subtitle">SSL 256-bit encryption</div>
        </div>
      </div>
    </div>
  );
}

// ── Main Page ──────────────────────────────────────────────────────────
export default function UpdatePaymentMethod({ type = "card" }) {
  // Pre-filled data from existing payment method

  const location = useLocation();

  const navigate = useNavigate();

  const paymentMethod = location.state?.paymentMethod;

  const paymentMethodId =
      paymentMethod?.payment_method_id;

  const [cvv, setCvv] = useState("");

  const [cardholderName, setCardholderName] =
    useState(
      paymentMethod?.card_holder_name || ""
    );

  const [cardNumber, setCardNumber] =
    useState(
      paymentMethod?.card_last4 || ""
    );

  const [expiry, setExpiry] =
    useState(
      paymentMethod
        ? `${paymentMethod.expiry_month}/${paymentMethod.expiry_year}`
        : ""
    );

  const [upiId, setUpiId] =
    useState(
      paymentMethod?.upi_id || ""
    );

  const [streetAddress, setStreetAddress] =
    useState(
      paymentMethod?.billing_address
        ?.street_address || ""
    );

  const [city, setCity] =
    useState(
      paymentMethod?.billing_address
        ?.city || ""
    );

  const [stateRegion, setStateRegion] =
    useState(
      paymentMethod?.billing_address
        ?.state_region || ""
    );

  const [zip, setZip] =
    useState(
      paymentMethod?.billing_address
        ?.postal_code || ""
    );

  const [isDefault, setIsDefault] =
    useState(
      paymentMethod?.is_default || false
    );

  const API_URL =
    process.env.REACT_APP_API_URL;

  const isCard = type === "card";

  const handleUpdatePaymentMethod =
    async () => {

      try {

        const cardLast4 =
          cardNumber
            .replace(/\s/g, "")
            .slice(-4);

        const response =
          await fetch(
            `${API_URL}/payment-methods/${paymentMethodId}`,
            {
              method: "PUT",

              headers: {
                "Content-Type":
                  "application/json",
              },

              body: JSON.stringify({

                card_holder_name:
                  cardholderName,

                card_brand:
                  paymentMethod?.card_brand,

                card_last4:
                  cardLast4,

                expiry_month:
                  expiry.split("/")[0],

                expiry_year:
                  expiry.split("/")[1],

                upi_id:upiId,

                street_address:
                  streetAddress,

                city,

                state_region:
                  stateRegion,

                postal_code:
                  zip,

                is_default:
                  isDefault,
              }),
            }
          );

        const result = await response.json();

        if (response.ok) {

          alert(result.message);

          navigate("/payments");

        } else {

          alert(result.detail || "Update failed");
        }

      } catch (error) {

        console.error(error);

        alert(
          "Unable to update payment method"
        );
      }
  };

  return (
    <div className="up-page">
      <Sidebar />

      <main className="up-main">
        {/* Header */}
        <div className="up-header">
          <div>
            <h1 className="up-header__title">
              {isCard ? "Update Payment Method" : "Update UPI Payment"}
            </h1>
            <p className="up-header__subtitle">
              {isCard
                ? "Edit your existing card details and billing information"
                : "Edit your existing UPI ID and billing information"}
            </p>
          </div>
          <Link
            to="/payments"
            className="page-header__back"
          >
            <Icons.ArrowLeft />
            Back to Payments
          </Link>
        </div>

        {/* Content */}
        <div className="up-content">
          <div className="up-form">
            {/* Active method banner */}
            <div className="up-banner">
              <div className="up-banner__left">
                <div className="up-banner__icon">
                  {isCard ? <Icons.CreditCard /> : <Icons.Smartphone />}
                </div>
                <span className="up-banner__text">
                  {paymentMethod?.payment_type === "CARD"
                    ? `Currently Active: ${paymentMethod.card_brand} ending in ${paymentMethod.card_last4}`
                    : `Currently Active: ${paymentMethod.upi_id}`
                  }
                </span>
              </div>
              <span className="up-banner__badge">Default</span>
            </div>

            {/* Card fields */}
            {isCard && (
              <>
                <div className="up-section">
                  <h3 className="up-section__title">Card Information</h3>
                  <p className="up-section__subtitle">
                    We support major secure credit and debit cards globally
                  </p>
                </div>
                <div className="up-fields">
                  <InputField
                    label="Card Number"
                    placeholder="4242 4242 4242 4242"
                    value={cardNumber}
                    onChange={(e) => setCardNumber(e.target.value)}
                    prefilled
                    suffix={
                      <>
                        <span className="up-brand up-brand--visa">VISA</span>
                        <span className="up-brand up-brand--mc">MC</span>
                        <span className="up-brand up-brand--amex">AMEX</span>
                      </>
                    }
                  />
                  <div className="up-fields__row">
                    <InputField
                      label="Expiration Date"
                      placeholder="MM / YY"
                      value={expiry}
                      onChange={(e) => setExpiry(e.target.value)}
                      prefilled
                    />
                    <InputField
                      label="CVV"
                      placeholder="•••"
                      value={cvv}
                      onChange={(e) => setCvv(e.target.value)}
                    />
                  </div>
                  <InputField
                    label="Cardholder Name"
                    placeholder="Full name on card"
                    value={cardholderName}
                    onChange={(e) => setCardholderName(e.target.value)}
                    prefilled
                  />
                </div>
              </>
            )}

            {/* UPI fields */}
            {!isCard && (
              <>
                <div className="up-section">
                  <h3 className="up-section__title">UPI Details</h3>
                  <p className="up-section__subtitle">
                    Use your registered UPI ID to link your account
                  </p>
                </div>
                <div className="up-fields">
                  <InputField
                    label="UPI ID"
                    placeholder="yourname@upi"
                    value={upiId}
                    onChange={(e) => setUpiId(e.target.value)}
                    prefilled
                  />
                  <p className="up-fields__note">
                    Supported UPI apps include Google Pay, PhonePe, Paytm, BHIM,
                    and other UPI-enabled wallets.
                  </p>
                </div>
              </>
            )}

            <div className="up-form__divider" />

            {/* Billing address (shared) */}
            <div className="up-section">
              <h3 className="up-section__title">Billing Address</h3>
              <p className="up-section__subtitle">
                Provide details associated with your card issuing account
              </p>
            </div>
            <div className="up-fields">
              <InputField
                label="Street Address"
                placeholder="Street address"
                value={streetAddress}
                onChange={(e) => setStreetAddress(e.target.value)}
                prefilled
              />
              <div className="up-fields__row up-fields__row--three">
                <InputField label="City" placeholder="City" value={city} onChange={(e) => setCity(e.target.value)} prefilled />
                <InputField label="State / Region" placeholder="State" value={stateRegion} onChange={(e) => setStateRegion(e.target.value)} prefilled />
                <InputField label="ZIP / Postal Code" placeholder="ZIP" value={zip} onChange={(e) => setZip(e.target.value)} prefilled />
              </div>
            </div>

            {/* Checkbox */}
            <label className="up-checkbox">
              <input type="checkbox" checked={isDefault} onChange={(e) => setIsDefault(e.target.checked)} />
              <span>Set as default payment method</span>
            </label>

            {/* Actions */}
            <div className="up-actions">
              <button
                className="up-btn up-btn--cancel"
                onClick={() => navigate("/payments")}
              >
                Cancel
              </button>
              <button
                className="up-btn up-btn--primary"
                onClick={
                  handleUpdatePaymentMethod
                }
              >
                {isCard
                  ? "Update Card"
                  : "Update UPI"}
              </button>
            </div>
          </div>

          {/* Preview sidebar */}
          {isCard ? (
            <CardPreview cardNumber={cardNumber} cardholderName={cardholderName} expiry={expiry} />
          ) : (
            <UpiPreview upiId={upiId} />
          )}
        </div>
      </main>
    </div>
  );
}